export const enableScroll = (scrollOffsetTop:number) => {
  document.documentElement.setAttribute('style', 'scroll-behavior:initial;');
  document.body.classList.remove('noscroll');
  window.scrollTo(0, scrollOffsetTop);

  document.documentElement.removeAttribute('style');
  return 0;
};

const checkEsc = (e: KeyboardEvent) => {
  if (e.isTrusted && e.code === 'Escape') {
    document.removeEventListener('keydown', checkEsc);
    const overlay = document.querySelector('.overlay--active');
    overlay?.classList.remove('overlay--active');
    const offset = parseInt(document.body.dataset.offset, 10) ?? 0;
    enableScroll(offset);
  }
};

export const disableScroll = () => {
  const scrollOffsetTop = window.scrollY;
  document.body.classList.add('noscroll');
  document.body.dataset.offset = `${scrollOffsetTop}`;
  document.body.setAttribute(
    'style',
    `--scrollOffsetTop:-${scrollOffsetTop}px;`,
  );

  document.addEventListener('keydown', checkEsc);

  return scrollOffsetTop;
};
